import dayjs from 'dayjs';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../api/axios';
import { deleteSensorFromContract, editContract } from './clients-slice';
import type { SensorsState } from '../../types/store';

const initialState: SensorsState = {
  data: [],
  status: 'idle',
  error: null,
};

export const fetchSensors = createAsyncThunk('sensors/fetchSensors', async () => {
  try {
    const response = await axios.get('sensors?limit=1000');
    return response.data;
  } catch (error) {
    console.error('Error fetching sensors:', error);
    throw error;
  }
});

const sensorsSlice = createSlice({
  name: 'sensors',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSensors.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSensors.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSensors.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteSensorFromContract.fulfilled, (state, action) => {
        state.data = state.data.filter((sensor) => sensor.sensor_id !== action.payload.sensorId);
      })
      .addCase(editContract.fulfilled, (state, action) => {
        const payloadData = action.payload.data;
        if (!payloadData) return;

        const sinceTs = payloadData.since;
        const untilTs = payloadData.until;
        if (!sinceTs && !untilTs) return;

        state.data = state.data.map((sensor) => {
          if (sensor.contract_id === payloadData.contract_id) {
            const _sensor = { ...sensor };
            if (sinceTs) {
              _sensor.since = sinceTs;
            }
            if (untilTs) {
              _sensor.until = untilTs;
            }
            const now = dayjs().valueOf();
            _sensor.active = now >= (sinceTs ?? sensor.since) && now <= (untilTs ?? sensor.until);
            return _sensor;
          }
          return sensor;
        });
      });
  },
});

export default sensorsSlice.reducer;
